const { createSlice } = require("@reduxjs/toolkit");
const initialState = {
    supplement: [],
    supplement: null,
    loading: false,
    error: null,
};

const supplementSlice = createSlice({
    name: "supplement",
    initialState,
    reducers: {
      setSupplementsState: (state, { payload }) => {
            state.supplement = payload;
        },
        setSupplementState: (state, { payload }) => {
            state.supplement = payload;
        },
        setLoading: (state, { payload }) => {
            state.supplement = payload;
        },
        setError: (state, { payload }) => {
            state.error = payload;
        },
    },

});

export const { setSupplementsState, setSupplementState, setLoading, setError } =
supplementSlice.actions;

export default supplementSlice.reducer;
